import { Card } from "@/src/components/cards";
import { openConfirmDialog } from "@/src/components/dialogs";
import {
  Hospitalisation,
  Patient,
  InitialExamination,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  formatDate,
  getDayCount,
  getItemId,
  getUserId,
  getUserShortName,
  isToday,
} from "@/src/utils/utils";
import openEvolutionItemStandardForm from "../openEvolutionItemStandardForm";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";
import { USER } from "@/src/data/globalVariables";

export default function InitialExaminationCard({
  item,
  patient,
  parent,
  onClick,
  onChange,
}: {
  item: InitialExamination | null | undefined;
  patient: Patient;
  parent: Hospitalisation;
  onClick: () => void;
  onChange: (item: InitialExamination) => void;
}) {
  if (!item?.id)
    return (
      <div
        className="card redish tcenter"
        onClick={async () => {
          let item: InitialExamination = {
            type: "initialExamination",
            patient,
            creator: getUserId(),
            parent,
            functionalSigns: [],
            physicalSigns: [],
            readBy: [getUserId()],
            confidentiality: getStandardConfidentiality(patient),
          };
          
          console.log("speciality", USER.get()?.speciality);

          await openEvolutionItemStandardForm({
            item,
            patient,
            onConfirm: async (newItem) => {
              newItem = await apiFetch("initialExaminations", "addOne", {
                initialExamination: newItem,
              });
              onChange?.(newItem);
            },
          });
        }}
      >
        <div className="bold">Examen clinique initial</div>
        <div>Aucune donnée saisie</div>
      </div>
    );

  return (
    <Card
      color={"blue"}
      leading={
        <div className=" mtop5 left br mright5">
          <div className="bold">{getDayCount(parent?._date, item._date)}</div>
          <div className="gray">{formatDate(item._date, "HH:mm")}</div>
        </div>
      }
      title={"Examen clinique initial"}
      subTitle={getUserShortName(item?.creator) || ""}
      onEdit={async () => {
        await openEvolutionItemStandardForm({
          item,
          patient,
          onConfirm: async (newItem) => {
            newItem = await apiFetch("initialExaminations", "addOne", {
              initialExamination: newItem,
            });
            onChange?.(newItem);
          },
        });
      }}
      onClick={async () => {
        await onClick();
      }}
      onDelete={
        getUserId() == getItemId(item.creator) && isToday(item._date)
          ? async () => {
              await openConfirmDialog({
                content: "Voulez-vous vraiment supprimer cet élément ?",
                onConfirm: async () => {
                  await apiFetch("initialExaminations", "deleteOne", {
                    id: item.id,
                  });
                  onChange?.(item);
                },
              });
            }
          : undefined
      }
    ></Card>
  );
}
